import MealSelectedUIModel from './meal-selected';

class MealsSelectedCollectionUIModel {
  constructor(obj) {
    this.items = [];
    if (obj !== null) {
      let item = null;
      const mealItems = [];
      obj.map(mealSelected => {
        mealSelected._collection.map ( meal => {
          item = new MealSelectedUIModel(meal);
          mealItems.push(item);
        });
      });
      this.items = mealItems;
    }
  }

  getItems() {
    return this.items;
  }
}

export default MealsSelectedCollectionUIModel;
